/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

const ChatButton = (props) => {
  const {
    text, className, dtmTagName, dtmAttributes, iconClass, handleClick, isDirectoryView
  } = props;
  return (
    <div data-testid="Chat-Button" className="clear-fix">
      { isDirectoryView
        && (
        <div
          className={`${className} mobile-view-icon`}
          data-dtm={dtmTagName}
          data-dtm-attributes={dtmAttributes}
          onClick={handleClick}
          role="button"
          tabIndex={0}
        >
          <div className={iconClass} />
        </div>
        )}
      <div
        className={`${className} desktop-view-icon`}
        data-dtm={dtmTagName}
        data-dtm-attributes={dtmAttributes}
        onClick={handleClick}
        role="button"
        tabIndex={0}
      >
        <div className={iconClass} />
        {text}
      </div>
    </div>
  );
};

ChatButton.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  dtmTagName: PropTypes.string,
  dtmAttributes: PropTypes.string,
  iconClass: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  isDirectoryView: PropTypes.bool
};

export default ChatButton;
